export default "__VITE_ASSET__Dga500f7__"